import type { Monitor } from "@suse-o11y/signal";

import { FormState } from "../_form-state";

/**
 * Converts the current state of the form into a unknown specification object.
 *
 * @param monitor
 * @param form - The form state.
 * @returns An unknown value representing the widget `spec` field.
 */
export function formToUnknown(monitor: Monitor, form: FormState): unknown {
	const output = form.getOutput(monitor, (_, verbose) => verbose);

	// Use only the `spec` part in the editor
	return FormState.toSpec(output).toPerses().spec;
}
